import { mapState, mapMutations } from "vuex";
import AppCard from "@/components/AppCard";
import ContentMixin from "@/mixins/ContentMixin.vue";
import AppIcon from "@/components/AppIcon";
import { EVENTS } from "@/utils";
export default {
  name: "SEOPushStatusFilter",
  components: {
    AppIcon,
    AppCard
  },
  mixins: [ContentMixin],
  props: {
    status: String,
    statusClass: String,
    icon: String,
    iconSize: Number,
    iconHoverColor: String,
    iconDefaultColor: String,
    pushStatusList: Array,
    loading: Boolean
  },
  data() {
    return {
      isHovering: false,
      isActivated: false
    };
  },
  computed: {
    ...mapState({
      push_status_selected: state => state.content.push_status_selected
    })
  },
  methods: {
    ...mapMutations(["contentCurrentModeSet", "contentPushStatusSelectedUpdate"]),
    onHover() {
      this.isHovering = true;
    },
    onLeave() {
      this.isHovering = false;
    },
    async onClickPushStatusFilter() {
      this.isActivated = !this.isActivated;
      this.contentPushStatusSelectedUpdate(this.status);
      await window.$bus.trigger(EVENTS.REFRESH_SEO_PAGE_CONTENT_TABLE);
    }
  }
};